import styled from 'styled-components';

import { Suspense } from '#src/atoms/Suspense/index.tsx';
import { LoadingIndicator } from '#src/atoms/loader/LoadingIndicator/index.tsx';
import { Dialog } from '#src/components/dialog/index.tsx';
import { useIsLaptop } from '#src/hooks/device/useIsLaptop.ts';
import { lazy } from '#src/lib/retry.ts';

const MultiSportSearchBar = lazy(
  async () => import('#src/components/search/MultiSportSearchBar/index.tsx'),
  'MultiSportSearchBar'
);

const StyledDialog = styled(Dialog)`
  top: 0;
  padding: var(--unit);
  margin: 0 auto auto auto;
  border-radius: var(--radius-m);
`;

type Props = { open?: boolean; onClose?: () => void };
export const SearchBarDialog = ({ onClose, open = true }: Props) => {
  const isLaptopAndAbove = useIsLaptop();

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      fullScreen={!isLaptopAndAbove}
      maxWidth="sm"
      fullWidth
      hideHeader
      skipTransition
    >
      <div className="forceSearchbarForDesktop">
        <Suspense fallback={<LoadingIndicator />}>
          <MultiSportSearchBar
            onExit={false}
            onSelect={() => onClose?.()}
            onClose={onClose}
          />
        </Suspense>
      </div>
    </StyledDialog>
  );
};
